export default [
    {
        name: "WarehouseItemList",
        path: "warehouse-items",
        component: () => import('./../../views/warehouse/WarehouseItemListView.vue')
    },
    {
        name: "WarehouseItemCreate",
        path: "warehouse/:warehouseId/item",
        component: () => import('./../../views/warehouse/WarehouseItemCreateView.vue')
    },
    {
        name: "WarehouseItemEdit",
        path: "warehouse/:warehouseId/item/:itemId",
        component: () => import('./../../views/warehouse/WarehouseItemEditView.vue')
    }
]